<mat-sidenav-container class="all-wrap" fullscreen>

  <div class="page-wrap">
    <app-header></app-header>

    <main class="flex-container">
      <app-alert-message></app-alert-message>
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>

  </div>
</mat-sidenav-container>

